import type React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { ProtectedRouteView } from '../components/SignInRequired';
import { useUser } from '../hooks';

const ProtectedLayout: React.FC = () => {
  const { isAuthenticated, idToken, login } = useUser();
  const navigate = useNavigate();

  if (!(isAuthenticated && idToken)) {
    return <ProtectedRouteView onSignIn={() => login()} onBack={() => navigate('/')} />;
  }

  return <Outlet />;
};

export default ProtectedLayout;
